import React from "react";
import ReactDOM from "react-dom";
import { ThemeProvider } from "emotion-theming";
import smoothscroll from "smoothscroll-polyfill";

import theme from "~/scripts/theme";
import getPolyglot from "~/scripts/polyglot";

import Explainer2 from "~/components/Explainer-2";
import Drawer from "~/components/Drawer";
import Map from "~/components/Map";
import Table from "~/components/Table";
import LastElection from "~/components/LastElection";

// kick off the polyfill!
smoothscroll.polyfill();

const locale = process.env.LOCALE || "de";
const polyglot = getPolyglot(locale);
export const TranslationContext = React.createContext(polyglot);

function renderWithTheme(children, id) {
  const domEl = document.getElementById(id);

  if (domEl) {
    ReactDOM.render(
      <ThemeProvider theme={theme}>
        <TranslationContext.Provider value={polyglot}>
          {children}
        </TranslationContext.Provider>
      </ThemeProvider>,
      domEl
    );
  }
}

function init() {
  renderWithTheme(<Explainer2 />, "gerrymandering-explainer-2");
  renderWithTheme(<Drawer />, "gerrymandering-drawer");
  renderWithTheme(<Map />, "gerrymandering-map");
  renderWithTheme(<Table />, "gerrymandering-table");
  renderWithTheme(<LastElection />, "gerrymandering-last-election");
}

export default {
  init,
};
